<template>
  <div style="display: inline">
    <v-btn
      v-if="!hideOpenButton"
      :disabled="disabled"
      :loading="loading"
      :class="[
        'worksansr',
        certificate &&
        protocol &&
        protocol_result == 'approved' &&
        use_certificate == 1
          ? 'btn-sign-cloud'
          : openClass,
      ]"
      :small="small"
      :x-small="x_small"
      @click="evOnBtnOpenClick"
    >
      <div
        v-if="
          certificate &&
          protocol &&
          protocol_result == 'approved' &&
          use_certificate == 1
        "
      >
        <i
          :class="[
            'mr-2',
            small && 'text-twenty',
            'fas',
            'fa-signature btn-icon',
          ]"
        ></i>
        <span v-if="validate">RT. VALIDAR COM CERTIFICADO EM NUVEM</span>
        <span v-if="!validate">ASSINAR COM CERTIFICADO EM NUVEM</span>
      </div>
      <div v-else>
        <i
          v-if="openLeftIcon"
          :class="[
            openText && 'mr-2',
            small && 'text-twenty',
            'fas',
            openLeftIcon,
          ]"
        ></i>
        {{ openText }}
        <i
          v-if="openRightIcon"
          :class="[
            openText && 'ml-2',
            small && 'text-twenty',
            'fas',
            openRightIcon,
          ]"
        >
        </i>
      </div>
    </v-btn>

    <b-modal
      :title="modalTitle"
      :header-class="headerClass"
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      centered
      :visible="isVisible"
      @change="evOnModalChange"
      @shown="onModalShown"
    >
      <b-row no-gutters>
        <b-col>
          <h6 class="upper-text text-eighteen color-blackfor">
            {{ messageTitle }}
          </h6>
          <p class="worksansr">{{ messageBody }}</p>
        </b-col>
      </b-row>
      <b-row align-h="between" no-gutters>
        <b-col cols="auto">
          <v-btn
            :disabled="disabled"
            :loading="loading"
            :class="['worksansr btn-modern btn-modern-delete', noClass]"
            @click="evOnBtnNoClick"
          >
            CANCELAR
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <v-btn
            :disabled="disabled"
            :loading="loading"
            :class="['worksansr btn-modern btn-modern-save', yesClass]"
            @click="evOnBtnYesClick"
          >
            <i
              v-if="yesLeftIcon"
              :class="['mr-2', 'text-twenty-five', 'fas', yesLeftIcon]"
            />
            {{ yesText }}
            <i
              v-if="yesRightIcon"
              :class="['mr-2', 'text-twenty-five', 'fas', yesRightIcon]"
            />
          </v-btn>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { userData } from "../../lib/functions";

export default {
  name: "ConfirmationDialog",

  props: {
    certificate: { type: Boolean, default: false },
    validate: { type: Boolean, default: false },

    value: { type: Boolean, default: false },

    modalTitle: { type: String, default: "CONFIRMAÇÃO" },
    messageTitle: { type: String, required: true },
    messageBody: { type: String, required: true },

    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },

    small: { type: Boolean, default: false },
    x_small: { type: Boolean, default: false },

    headerClass: { type: String, default: "modal-header-red" },

    hideOpenButton: { type: Boolean, default: false },
    openClass: { type: String, required: false },
    openLeftIcon: { type: String, default: "" },
    openRightIcon: { type: String, default: "" },
    openText: { type: String, required: false },

    noClass: { type: String, default: "btn-cancel" },
    noLeftIcon: { type: String, default: "" },
    noRightIcon: { type: String, default: "" },
    noText: { type: String, default: "CANCELAR" },

    yesClass: { type: String, default: "btn-save" },
    yesLeftIcon: { type: String, default: "" },
    yesRightIcon: { type: String, default: "" },
    yesText: { type: String, default: "CONFIRMAR" },
  },

  data() {
    return {
      isVisible: false,

      protocol: null,
      protocol_result: null,
      use_certificate: 0,
    };
  },

  watch: {
    value(newValue) {
      this.isVisible = newValue;
    },
  },

  created() {
    if (userData()) {
      if (userData().user) {
        let { protocol, protocol_result, use_certificate } = userData().user;

        this.protocol = protocol;
        this.protocol_result = protocol_result;
        this.use_certificate = use_certificate;
      }
    }
  },

  methods: {
    async onModalShown() {
      let { protocol, protocol_result, use_certificate } = userData().user;

      this.protocol = protocol;
      this.protocol_result = protocol_result;
      this.use_certificate = use_certificate;
    },

    async evOnModalChange(value) {
      this.isVisible = value;
      this.$emit("input", value);
    },

    async evOnBtnOpenClick() {
      this.isVisible = true;
      this.$emit("input", true);
    },

    async evOnBtnNoClick() {
      this.isVisible = false;
      this.$emit("input", false);
      this.$emit("no");
    },

    async evOnBtnYesClick() {
      this.isVisible = false;
      this.$emit("input", false);
      this.$emit("yes");

      let { certificate, protocol, protocol_result, use_certificate } = this;

      if (
        certificate &&
        protocol &&
        protocol_result == "approved" &&
        use_certificate == 1
      ) {
        this.$emit("certificate");
      }
    },
  },
};
</script>

<style scoped>
.btn-sign-cloud {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 16px !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-sign-cloud:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(78, 145, 48, 0.4) !important;
}

.btn-sign-cloud:disabled {
  opacity: 0.8 !important;
  cursor: not-allowed !important;
  transform: none !important;
}
</style>
 